<template>
  <authenticated-layout
    :back-route="{ name: 'users' }"
    :breadcrumbs="breadcrumbItems">
    <user-detail-content
      :user-id="userId"
      route-name="userDetail"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {useRoute} from "vue-router";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import UserDetailContent from "@/components/Users/UserDetailContent.vue";

const route = useRoute();
const userId = computed(() => route.params.userId as string);

const getUserNameOrId = computed(() => userId.value);

const breadcrumbItems = computed(() => [
  { text: "Users", to: { name: "users" } },
  { text: getUserNameOrId.value }
]);

</script>
